export default "__VITE_ASSET__BshedcLB__"